import { type FC, type MouseEvent } from "react";
import { usePermissions } from "../../../Utilities/Domain/Users/Permissions";
import FontAwesomeLight from "../../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import Button from "../../Buttons/Button";
import { Folder } from "./Folder";
import { type FolderListType } from "./MediaSelector";
import { type MediaPathType } from "./MediaUtilities";

interface Props {
    path: Array<MediaPathType>;
    folders: FolderListType;
    onToggle: (path: Array<MediaPathType>) => void;
    onChange: (path: Array<MediaPathType>) => void;
    onUpload: (e: MouseEvent) => void;
    onNewFolder: (e: MouseEvent) => void;
    onOverlayDisplay: (value: boolean) => void;
}

const permissions = [ "create_media_folder", "upload_media_content" ] as const;

export const FolderBrowser: FC<Props> = ({
    path,
    folders,
    onToggle,
    onChange,
    onUpload,
    onNewFolder,
    onOverlayDisplay,
}) => {
    const { createMediaFolder, uploadMediaContent } = usePermissions(permissions);

    const canUpload = path?.[0]?.id === "home";

    const onMouseEnter = (): void => {
        if(canUpload && uploadMediaContent) {
            onOverlayDisplay(true);
        }
    };

    const onMouseOut = (): void => {
        if(canUpload) {
            onOverlayDisplay(false);
        }
    };

    return (
        <div className="folder-browser">
            <div className="upload-button">
                <Button
                    onClick={onUpload}
                    onMouseEnter={onMouseEnter}
                    onMouseOut={onMouseOut}
                    disabled={!(
                        canUpload &&
                        uploadMediaContent
                    )}
                >
                    <FontAwesomeLight icon="cloud-upload" />Upload
                </Button>
            </div>
            <div className="actions">
                <Button
                    onClick={onNewFolder}
                    classes={[ "button-save" ]}
                    disabled={!(
                        canUpload &&
                        createMediaFolder
                    )}
                >
                    <FontAwesomeLight icon="plus" />New Folder
                </Button>
            </div>
            <div className="folders">
                <Folder
                    id="home"
                    current={path}
                    name="Home"
                    open={folders.home.open}
                    onToggle={onToggle}
                    subFolders={folders.home.children}
                    onChange={onChange}
                    layer={0}
                />
                <Folder
                    id="mdb"
                    current={path}
                    name="MDB"
                    open={folders.mdb.open}
                    onToggle={onToggle}
                    subFolders={folders.mdb.children}
                    onChange={onChange}
                    layer={0}
                />
            </div>
        </div>
    );
};
